import { render, staticRenderFns } from "./formater-map.vue?vue&type=template&id=1a237b90"
import script from "./formater-map.vue?vue&type=script&lang=js"
export * from "./formater-map.vue?vue&type=script&lang=js"
import style0 from "./formater-map.vue?vue&type=style&index=0&id=1a237b90&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports